import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userAge: JSON.parse(localStorage.getItem('userAge')) || null,
  },
  getters: {
    getUserAge: state => state.userAge,
  },
  mutations: {
    setUserAge(state, payload) {
      state.userAge = payload;
      if (payload) {
        localStorage.setItem('userAge', JSON.stringify(payload));
      } else {
        localStorage.removeItem('userAge');
      }
    },
    clearUserAge(state) {
      state.userAge = null;
      localStorage.removeItem('userAge');
    },
  },
  actions: {
    saveUserAge({ commit }, userAge) {
      commit('setUserAge', userAge);
    },
    clearUserAge({ commit }) {
      commit('clearUserAge');
    },
  },
  modules: {},
});